import ReleaseDetectionSettings from './ReleaseDetectionSettings';
import { SettingValues } from '@linearb/linjs-common';
import { myAccountSelector } from 'state/selectors/account.js';
import { connect } from 'react-redux';
import {
  validateInputs,
  getReleaseDetectionSettingsSubtext
} from './release-detection-settings.util';
import { toggleSnackBar, toggleModal } from 'state/callers';
import {
  CUSTOM_OPTIONS,
  RELEASE_DETECTION_STRATEGIES
} from './release-detection-settings.constants';

const additionalModalDisplayCheck = ({ stateValue, value }) => {
  const currKey = stateValue.key;
  const prevKey = value.key;
  const fromReported = prevKey === RELEASE_DETECTION_STRATEGIES.REPORTED;
  const isCurrentReported = currKey === RELEASE_DETECTION_STRATEGIES.REPORTED;
  return fromReported !== isCurrentReported;
};

const ReleaseDetectionSettingsWrapper = props => {
  const { definitionLevel, value } = props;
  const disabled = value?.key === RELEASE_DETECTION_STRATEGIES.DEPLOYMENT;

  return (
    <ReleaseDetectionSettings
      key={SettingValues.RELEASES_STRATEGY}
      name={SettingValues.RELEASES_STRATEGY}
      namespace='releases'
      allCustomOptions={CUSTOM_OPTIONS}
      title='Release Detection Strategy'
      additionalModalDisplayCheck={additionalModalDisplayCheck}
      buttonsContainerFlexDirection={'flex-start'}
      descriptionTextWidth='35rem'
      useEffectValidationFN={validateInputs}
      label={'Releases detection'}
      defaultValue={{
        key: 'tag',
        regex_pattern: '.*',
        backfill_days_backward: 90
      }}
      subtext={getReleaseDetectionSettingsSubtext(definitionLevel)}
      disabled={disabled}
      {...props}
    />
  );
};

const mapStateToProps = state => ({
  account: myAccountSelector(state)
});
const mapDispatchToProps = {
  toggleSnackBar,
  toggleModal
};

export default connect(mapStateToProps, mapDispatchToProps)(
  ReleaseDetectionSettingsWrapper,
  'Release Detection Settings'
);
